import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { GroupHasLoyaltyTypeAndIsActive } from './models/entity-notification-group.model';
import { NotificationManagementState, NotificationManagementStore } from './notification-management.store';
import { NotificationLoyaltyType } from '../notification-loyalty-type.enum';

@Injectable({ providedIn: 'root' })
export class NotificationManagementQuery extends QueryEntity<NotificationManagementState> {
  constructor(protected store: NotificationManagementStore) {
    super(store);
  }

  /**
   * Checks the supplied loyaltyActionId against the store
   * and sees if the user allows this notification to be shown or if the notification is critical
   */
  loyaltyTypeIsActive(loyaltyActionId: NotificationLoyaltyType): boolean {
    if (loyaltyActionId === NotificationLoyaltyType.None) {
      return true;
    }

    for (const group of this.getAll()) {
      const active = GroupHasLoyaltyTypeAndIsActive(group, loyaltyActionId);
      if (active) {
        return true;
      }
    }

    return false;
  }
}
